import { isNativeApp } from './platform';

const LOCK_KEY        = 'tt_app_lock';
const LOCK_DELAY_KEY  = 'tt_app_lock_delay';   // ms as string, or 'never'
const LAST_UNLOCK_KEY = 'tt_app_last_unlock';  // ms timestamp of last unlock

// Whether the user has turned on biometric App Lock (device-local preference).
export function isAppLockEnabled() {
  return isNativeApp() && localStorage.getItem(LOCK_KEY) === '1';
}
export function setAppLockEnabled(on) {
  if (on) localStorage.setItem(LOCK_KEY, '1');
  else localStorage.removeItem(LOCK_KEY);
}

// How long the app may sit in the background before it re-locks. 'never' means
// it never re-locks on backgrounding — it only asks again on a fresh launch
// once 6h have passed since the last unlock.
export const LOCK_DELAY_OPTIONS = [
  { value: '0',       label: 'Immediately' },
  { value: '30000',   label: 'After 30 seconds' },
  { value: '60000',   label: 'After 1 minute' },
  { value: '120000',  label: 'After 2 minutes' },
  { value: '300000',  label: 'After 5 minutes' },
  { value: '600000',  label: 'After 10 minutes' },
  { value: '900000',  label: 'After 15 minutes' },
  { value: '1800000', label: 'After 30 minutes' },
  { value: '3600000', label: 'After 1 hour' },
  { value: '7200000', label: 'After 2 hours' },
  { value: 'never',   label: 'Never (only after 6h on relaunch)' },
];
export const NEVER_COLD_MS = 6 * 60 * 60 * 1000; // 6h

export function getLockDelay() {
  return localStorage.getItem(LOCK_DELAY_KEY) || '60000'; // default: 1 minute
}
export function setLockDelay(v) {
  localStorage.setItem(LOCK_DELAY_KEY, String(v));
}
export function markUnlocked() {
  try { localStorage.setItem(LAST_UNLOCK_KEY, String(Date.now())); } catch {}
}
export function getLastUnlock() {
  return parseInt(localStorage.getItem(LAST_UNLOCK_KEY) || '0', 10);
}

// Is a fingerprint/face sensor usable on this device?
export async function biometricAvailable() {
  if (!isNativeApp()) return { available: false, type: null };
  try {
    const { NativeBiometric } = await import('capacitor-native-biometric');
    const r = await NativeBiometric.isAvailable();
    return { available: !!r?.isAvailable, type: r?.biometryType ?? null };
  } catch {
    return { available: false, type: null };
  }
}

// Prompt for biometric verification. Resolves true on success, false otherwise.
export async function verifyBiometric(reason = 'Unlock Toppers Tutorial') {
  if (!isNativeApp()) return true;
  try {
    const { NativeBiometric } = await import('capacitor-native-biometric');
    await NativeBiometric.verifyIdentity({
      reason,
      title: 'Toppers Tutorial',
      subtitle: 'Confirm it’s you',
      description: reason,
    });
    return true;
  } catch {
    return false;
  }
}
